<template>
    <b-col col-lg-6 col-sm-12  v-if="billingLoading == false">
        <b-card v-if="userStore.profile.showSubview">
            <div v-if="userStore.profile.canceled !=true">
                <div class="d-flex justify-content-between align-items-start mb-1">
                    <span class="badge bg-light-warning text-sm" style="font-size:11px;" v-if="user_subscription_ended">
                        {{ userStore.profile.user.my_plan }}
                    </span>
                    <span class="badge bg-light-primary text-sm" style="font-size:11px;" v-else>{{plan}}</span>
                </div>
                <div class="d-flex justify-content-start mb-1" v-if="!user_subscription_ended">
                    <span class="badge bg-light-primary text-sm" style="font-size:11px;">{{plan.title}}</span>
                </div>
                <div class="d-flex justify-content-start mb-1">
                    <sup class="h5 pricing-currency text-primary mt-0 mb-0"></sup>
                    <span class="display-5 mb-0 text-primary" style="font-weight:bolder;">{{subscriptionAmount}}</span>
                    <span>/</span>
                    <span>month</span>
                </div>
                <ul class="ps-1 mb-2">
                    <li class="mb-50" v-if="userStore.profile.canceled">
                        <h5 v-if="nextPaymentAttempt !== 0" style="font-weight:bolder;">
                            Subscription ends on {{nextPaymentAttempt}}
                        </h5>
                        <h5 v-else style="font-weight:bolder;">
                            Subscription Is Inactive
                        </h5>
                    </li>
                    <li class="mb-50" v-else><h5 style="font-weight:bolder;">Plan Renews On {{nextPaymentAttempt}}</h5></li>
                    <!-- <li class="mb-50">We will send you a notification upon subscription expiration</li> -->
                </ul>
                <div class="d-flex justify-content-between align-items-center fw-bolder mb-50">
                    <span>Days</span>
                    <span>{{paymentBar.subDifference}} of {{paymentBar.totalDay}} Days</span>
                </div>
                <div class="progress mb-50" style="height: 8px">
                    <div class="progress-bar" role="progressbar" :style="{width:paymentBar.percentageDate+'%'}" aria-valuenow="65" aria-valuemax="100" aria-valuemin="80"></div>
                </div>
                <span v-if="userStore.profile.canceled">Subscription Has Ended.</span>
                <!-- <span v-else-if="userStore.profile.canceled==''">{{paymentBar.remainingDate}} days remaining until renewal.</span> -->
                <span v-else>
                    <span v-if="paymentBar.remainingDate > 0">{{paymentBar.remainingDate}} days remaining until renewal</span>
                    <span v-else>Subscription Has Ended.</span>
                </span>
                <div class="d-grid w-100 mt-2">
                    <button
                        class="btn btn-light waves-effect waves-float waves-light col-12"
                        @click="resumeSubscription()"
                        v-if="userStore.profile.canceled"
                    >
                        Resume Subscription
                    </button>
                    <div v-else>
                        <div v-if="plan == 'On Trial' || plan == 'On Year End Sale' || plan == 'On Black Friday Sale'">
                            <button
                                class="btn btn-outline-warning waves-effect waves-float waves-light mb-1 col-12"
                                @click="billingStore.cancelSubscription(billingStore.END_TRIAL)"
                            >
                                End Trial
                            </button>
                            <button
                                class="btn btn-warning waves-effect waves-float waves-light col-12"
                                @click="billingStore.cancelSubscription(billingStore.END_TRIAL_START_SUBSCRIPTION)"
                            >
                                End Trial And Start Subscription
                            </button>
                        </div>
                        <div v-else>
                            <a
                                href="javascript:void(0)"
                                class="btn btn-outline-danger suspend-user waves-effect mr-2 mb-2"
                                data-target="#deactivate-reason-modal"
                                data-toggle="modal"
                                @click="userStore.deactivate_type = userStore.CANCEL_SUBSCRIPTION"
                            >
                                Cancel My Subscription
                            </a>
                            <router-link
                            :to="{ name: 'billing-subscriptions-plan'}"
                            aria-current="page"  class="btn btn-outline-primary suspend-user waves-effect mb-2" target="_self"
                            >
                                <span class="menu-title text-truncate">{{ localizationStore.translate('billing') }}</span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <h4 class="mb-2" style="font-weight:bolder;">
                    Canceled Subscription
                </h4>
                <div class="d-flex justify-content-between align-items-start mb-1">
                    <span class="badge bg-light-primary text-sm" style="font-size:11px;">{{ plan }}</span>
                </div>
                <div class="d-flex justify-content-start mb-1">
                    <sup class="h5 pricing-currency text-primary mt-0 mb-0"></sup>
                    <span class="display-5 mb-0 text-primary" style="font-weight:bolder;">{{ subscriptionAmount }}</span>
                    <span>/</span>
                    <span>month</span>
                </div>
                <h5 style="font-weight:bolder;">
                    Your Subscription Ends On:
                </h5>
                <h6>
                    {{endsAt}}
                </h6>
                <button
                    class="btn btn-light waves-effect waves-float waves-light col-12 mt-2"
                    @click="resumeSubscription()"
                    v-if="userStore.profile.canceled"
                >
                    Resume Subscription
                </button>
            </div>
        </b-card>
        <b-card v-else-if="userStore.profile.has_incomplete_payment">
            <a
                :href="userStore.profile.billingPortal"
                class="btn btn-primary waves-effect waves-float waves-light col-12 mt-2"
                target="_blank"
            >
                Billing Portal
            </a>
        </b-card>
        <b-card v-else>
            <div class="d-flex justify-content-center align-items-start mb-1">
                <h2 class="badge bg-light-warning " style="font-size:16px;">No Active Trial or Subscription.</h2>
            </div>
            <router-link
                :to="{ name: 'billing-plans'}"
                class="btn btn-primary waves-effect waves-float waves-success col-12 mt-2"
            >
                {{ localizationStore.translate('user.profile.subscription.button.title') }}
            </router-link>
        </b-card>
    </b-col>
</template>
<script>
    import { BCard } from "bootstrap-vue-3"
    import SubscriptionPlan from '../../../components/billing/SubscriptionPlan.vue'
    import { useBillingStore } from '../../../stores/BillingStore.js'
    import { useUserStore } from '../../../stores/UserStore.js'
    import { useLocalizationStore } from '../../../stores/LocalizationStore.js'
    import Swal from 'sweetalert2'

  export default{
    name:"UserPlanView",
    components:{
      BCard,SubscriptionPlan
    },
    data(){
      return{
        plan:'Plan',
        userID:'',
        nextPaymentAttempt:'',
        subscriptionAmount:'',
        paymentBar:{},
        showRenew:'',
        user_subscription_ended:false,
        endsAt:'',
        billingLoading:true,
      }
    },
    setup(){
        return {
            billingStore: useBillingStore(),
            userStore: useUserStore(),
            localizationStore: useLocalizationStore(),
        }
    },
    watch: {
        'userStore.profile'(value) {
            this.setUserInformation(value);
        },
    },
    mounted(){
        let $this = this;
        if (document.readyState === "complete") {
            setTimeout(() => {
                this.$nextTick(() => {
                    if(!_.isEmpty(this.userStore.profile)){
                        $this.setUserInformation(this.userStore.profile);
                    }else{
                        $this.userStore.fetchUserProfile();
                    }
                });
            }, 2000);
        } else {
            window.addEventListener("load", () => {
                setTimeout(() => {
                    this.$nextTick(() => {
                        if(!_.isEmpty(this.userStore.profile)){
                            $this.setUserInformation(this.userStore.profile);
                        }else{
                            $this.userStore.fetchUserProfile();
                        }
                    });
                }, 2000);
            });
        }
    },
    methods: {
        setUserInformation(data){
            this.plan = data.plan;
            this.nextPaymentAttempt = data.nextPaymentAttempt;
            this.subscriptionAmount = data.subscriptionAmount;
            this.paymentBar = data.paymentBar;
            this.userID=data.user.id;
            this.endsAt = data.endsAt
            this.user_subscription_ended = data.user_subscription_ended
            this.billingLoading=false
        },
        resumeSubscription(){
            const $this = this;
            Swal.fire({
                title: $this.localizationStore.translate('are.you.sure'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, resume subscription!',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    const route = $this.$router.resolve(
                        {
                            name: 'billing-subscriptions-resume',
                        }
                    );
                    axios.post(route.href)
                    .then(function(response) {
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        toastr.success(response.data.message, 'Success!');
                        setTimeout(() => {window.location.reload();}, 1000)
                        return;
                    }).catch(function(error) {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    });
                }
            });
        },
    },
  }
</script>
